import script from "./TutorialWithLoaderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialWithLoaderPage.vue?vue&type=script&setup=true&lang=js"

import "./TutorialWithLoaderPage.vue?vue&type=style&index=0&id=2516d702&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2516d702"]])

export default __exports__